import { render } from "./NavigationComponent.vue?vue&type=template&id=3535a69c&ts=true"
import script from "./NavigationComponent.vue?vue&type=script&lang=ts"
export * from "./NavigationComponent.vue?vue&type=script&lang=ts"

import "./scss/styles.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__